/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionSpotlightModule_componentModule = {
    readonly messages: {
        readonly title: string | null;
        readonly description: string | null;
        readonly isCollection: boolean | null;
        readonly videoEmbedId: string | null;
        readonly linkText: string | null;
        readonly cta: string | null;
        readonly collectionImage: {
            readonly imageUrl: string | null;
            readonly imageWidth: string | null;
            readonly imageHeight: string | null;
        } | null;
        readonly collectionPhoneImage: {
            readonly imageUrl: string | null;
            readonly imageWidth: string | null;
            readonly imageHeight: string | null;
        } | null;
        readonly profileImage: {
            readonly imageUrl: string | null;
            readonly imageWidth: string | null;
            readonly imageHeight: string | null;
        } | null;
        readonly image: {
            readonly imageUrl: string | null;
            readonly imageWidth: string | null;
            readonly imageHeight: string | null;
        } | null;
        readonly linkData: {
            readonly path: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SeoButton_linkData">;
        };
        readonly items: ReadonlyArray<{
            readonly title: string | null;
            readonly itemId: string | null;
            readonly contemporaryTrackingString: string | null;
            readonly linkData: {
                readonly path: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionSpotlightItem_item">;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespCollectionSpotlightModule_componentModule";
};
export type HpRespCollectionSpotlightModule_componentModule$data = HpRespCollectionSpotlightModule_componentModule;
export type HpRespCollectionSpotlightModule_componentModule$key = {
    readonly " $data"?: HpRespCollectionSpotlightModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionSpotlightModule_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "imageUrl",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "imageWidth",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "imageHeight",
    "args": null,
    "storageKey": null
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespCollectionSpotlightModule_componentModule",
  "type": "CollectionSpotlightModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "messages",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "CollectionSpotlightItemMessages",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isCollection",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "videoEmbedId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "linkText",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cta",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "collectionImage",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionSpotlightImageType",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "collectionPhoneImage",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionSpotlightImageType",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "profileImage",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionSpotlightImageType",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "image",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionSpotlightImageType",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "SeoButton_linkData",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionSpotlightItem",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "itemId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "contemporaryTrackingString",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "linkData",
              "storageKey": null,
              "args": null,
              "concreteType": "LinkData",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespCollectionSpotlightItem_item",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '2923231f5d393e0bd74cf108178f5610';
export default node;
